import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from 'theme/breakpoints';
import Tippy from '@tippyjs/react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import checkmark from 'img/ui/checkmarkGreen.svg';
import cross from 'img/ui/cross.svg';

const StyledList = styled.ul`
  padding: 0;
  display: flex;
  flex-direction: column;
  list-style: none;
  &.compare {
    li {
      width: 100%;
    }
  }
  li {
    height: 64px;
    width: 100%;
    margin: 0 auto;
    font-size: 16px;
    font-weight: 800;
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:first-of-type {
      margin-top: 20px;
    }
    span {
      font-weight: 400;
      display: inline-block;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
      line-height: normal;
      font-size: 18px;
    }
    p {
      font-weight: 400;
      margin: 0;
    }
    & span.planned {
      display: inline-block;
      align-items: center;
      justify-content: center;
      font-style: normal;
      color: #000;
      height: 24px;
      border-radius: 4px;
      font-size: 13px;
      font-weight: 800;
      line-height: 24px;
      text-align: center;
      padding: 0 8px;
      text-decoration: none;
      border: none;
      white-space: nowrap;
    }
    .icon-cross {
      color: #f50057;
    }
  }
  ${media.tablet} {
    max-width: 576px;
    margin: 0 auto;
  }
`;

const PaginationWrapper = styled.div`
  width: 100%;

  ${media.tablet} {
    max-width: 576px;
    margin: 0 auto;
  }

  .pagination {
    border-bottom: 1px solid #e4e5e8;
    border-radius: 0;
    justify-content: space-evenly;
    padding: 0;
    margin-bottom: 0;
  }
  .page-item {
    border-bottom: 2px solid #fff;
    width: 100%;
    text-align: center;
    & img {
      max-width: 24px;
    }
  }
  .page-link {
    font-size: 18px;
    font-weight: 700;
    border: none;
    background-color: transparent;
    color: #000;
    outline: 0 !important;
    padding: 0 0 12px;
  }
  .page-item.active {
    border-bottom: 2px solid #0a4ed6;
    .page-link {
      background-color: transparent;
      color: #000;
      outline: 0 !important;
      border-color: transparent;
      &:focus {
        box-shadow: none;
      }
    }
  }
`;
const List = styled.div`
  display: none;
  margin-top: 64px;
  ${media.tablet} {
    display: block;
  }
`;

const IconContainer = styled.div`
  flex-basis: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  &.cross {
    background-color: #f5005708;
    border-radius: 4px;
    &.planned {
      background-color: transparent;
    }
  }
`;

const TableMobile = ({ pages, data, compare }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const handleClick = (e, index) => {
    e.preventDefault();
    setCurrentPage(index);
  };

  const renderIcon = (item) => {
    return typeof item === 'string' ? (
      item.includes('check') ? (
        <img src={checkmark} alt="check" />
      ) : (
        <>
          {!item.includes('planned') && <img src={cross} alt="cross" />}
          {item.includes('planned') && <span className="planned">Coming soon</span>}
        </>
      )
    ) : (
      item
    );
  };

  return (
    <List>
      <PaginationWrapper className={['pagination-wrapper', compare && 'compare'].join(' ')}>
        <Pagination aria-label="Page navigation">
          {pages.map((page) => (
            <PaginationItem active={page.key === currentPage} key={page.key}>
              <PaginationLink onClick={(e) => handleClick(e, page.key)} href="#">
                {page.icon} {page.name}
              </PaginationLink>
            </PaginationItem>
          ))}
        </Pagination>
      </PaginationWrapper>
      <StyledList className={[compare && 'compare']}>
        {data.map((item, i) => (
          <li key={item.name}>
            {item.tooltip ? (
              <Tippy content={item.tooltip} placement="bottom-start">
                <span>{item.name}</span>
              </Tippy>
            ) : (
              <p>{item.name}</p>
            )}
            <IconContainer
              className={[
                typeof pages[currentPage].base[i] === 'string' &&
                pages[currentPage].base[i].includes('cross')
                  ? 'cross'
                  : '',
                pages[currentPage].base[i].includes('planned') ? 'planned' : '',
              ].join(' ')}
            >
              {renderIcon(pages[currentPage].base[i])}
            </IconContainer>
          </li>
        ))}
      </StyledList>
    </List>
  );
};

export default TableMobile;

TableMobile.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      base: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired,
      key: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
    }),
  ).isRequired,
  compare: PropTypes.bool,
};

TableMobile.defaultProps = {
  compare: false,
};
